const Index = () => import("./index.vue");
const Prices = () => import("./prices.vue");
const BuyingPrices = () =>
  import("./non-uom-bp-prices.vue");
const UomPrices = () =>
  import("./uom-prices.vue");
const NonUomPrices = () =>
  import("./non-uom-prices.vue");
const ViewUomProduct = () =>
  import("./view-uom-product.vue");
const CreatePage = () =>
  import("./_pages/create.vue");
const ViewPage = () =>
  import("./_pages/view.vue");
const ManagePage = () =>
  import("./_pages/manage.vue");
const ImportPage = () =>
  import("./_pages/import.vue");
const ManagePriceList = () =>
  import("./manage-price-list.vue");
const CopyPriceList = () =>
  import("./copy-price-list.vue");
const ImportPriceLists = () =>
  import("./import-price-lists.vue");

const ImportBuyingPricesPage = () =>
  import("./_pages/import-bps.vue");
// const SinglePage = () => import('./_pages/single.vue');
// const MultiplePage = () => import('./_pages/multiple.vue');

export default [
  {
    path: "/copy-price-list",
    component: CopyPriceList,
  },
  {
    path: "/price-lists",
    component: Index,
  },
  {
    path: "/import-price-lists",
    component: ImportPriceLists,
  },
  {
    path: "/manage-price-list/:id",
    component: ManagePriceList,
  },
  {
    path: "/prices",
    component: Prices,
  },
  {
    path: "/uom-product/:id",
    component: ViewUomProduct,
  },
  {
    path: "/manage-buying-prices",
    component: BuyingPrices,
  },
  {
    path: "/non-uom-price-list",
    component: NonUomPrices,
  },
  {
    path: "/uom-price-list",
    component: UomPrices,
  },
  {
    path: "/new-price-list",
    component: CreatePage,
  },
  {
    path: "/price-lists/:id",
    component: ViewPage,
  },
  {
    path: "/price-lists/manage/:id",
    component: ManagePage,
  },
  {
    path: "/price-lists/import/:id",
    component: ImportPage,
  },
  {
    path: "/import-buying-prices/:id",
    component: ImportBuyingPricesPage,
  },
];
